// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrCode {\n  width: 3.2rem;\n  height: 3.2rem;\n  background: #D8D8D8;\n  margin: 0.08rem auto 0.14rem;\n}\n.qrCode .qrCode-size {\n  width: 3.2rem !important;\n  height: 3.2rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
